// eslint-disable-next-line no-irregular-whitespace
const KATAKANA_PATTERN = /^[ァ-ヶー　]+$/;

export const isKatakana = (value: string): boolean => {
  return KATAKANA_PATTERN.test(value);
};

export const validateKatakana = (name: string, value: string): string | undefined => {
  if (!isKatakana(value)) {
    return `${name}はカタカナで入力してください`;
  }
  return undefined;
};
